import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
    IInitialStateNorms,
    INormsPayload
} from "../types";
import {
    GetDeleteNormTypes,
    GetNormTypes
} from "@pages/LearningManagement/Workload/components/WorkloadSettingsPages/WorkloadNormTypes/store/thunk";



const initialState: IInitialStateNorms = {
    norms: [],
    isViewRestoreNorms: false,
    isLoadingNorms: true,
    normsRestore: [],
    selectedNormsIDs: []
}

const normsSlice = createSlice({
    name: "norms",
    initialState,
    reducers: {
        setNorms: (state, action: PayloadAction<{data:INormsPayload[]}>) => {
            const { data } = action.payload;
            state.norms = data;
        },
        setIsViewRestoreNorms:(state) => {
            state.isViewRestoreNorms = !state.isViewRestoreNorms;
        },
        deletedRestoreNorms:(state,action)=>{
            state.normsRestore = state.normsRestore.filter((elem) => elem.id !== action.payload);
                },
        deleteNorms: (state, action: PayloadAction<number>) => {
            const id = action.payload;
            state.norms = state.norms.filter((elem) => elem.id !== id);

        },
        updateNorms: (
            state,
            action: PayloadAction< INormsPayload>
        ) => {
            const updateData = action.payload;

            state.norms = state.norms.map((elem) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },

        setSelectedNormsIDs: (state, action) => {
            state.selectedNormsIDs=action.payload
        },
        setNormsRestoreData:(state, action) => {
            state.normsRestore = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetNormTypes.pending, (state) => {
                state.isLoadingNorms = true;
            })
            .addCase(GetNormTypes.fulfilled, (state) => {
                state.isLoadingNorms = false;
            })
            .addCase(GetNormTypes.rejected, (state) => {
                state.isLoadingNorms = false;
            })
            .addCase(GetDeleteNormTypes.pending, (state) => {
                state.isLoadingNorms = true;
            })
            .addCase(GetDeleteNormTypes.fulfilled, (state) => {
                state.isLoadingNorms = false;
            })
            .addCase(GetDeleteNormTypes.rejected, (state) => {
                state.isLoadingNorms = false;
            });
    },
})
export const{
    setNorms,
    setIsViewRestoreNorms,
    deletedRestoreNorms,
    deleteNorms,
    updateNorms,
    setSelectedNormsIDs,
    setNormsRestoreData
}=normsSlice.actions

export default normsSlice